export default {
  loc_country_select: {
    rs: null,
    bg: null,
    ro: null,
    gr: null,
    hr: null,
    si: null,
    tr: null,
    hu: null,
    sk: null,
    cz: null,
    lt: null,
    es: null,
    pl: null,
  },
  loc_city_select: {
    rs_001: null,
    rs_002: null,
    rs_003: null,
    rs_004: null,
    rs_005: null,
    rs_006: null,
    rs_007: null,
    rs_008: null,
    rs_009: null,
    rs_010: null,
    rs_011: null,
    rs_012: null,
    rs_013: null,
    rs_014: null,
    rs_015: null,
    rs_016: null,
    rs_017: null,
    rs_018: null,
    rs_019: null,
    rs_020: null,
    rs_021: null,
    rs_022: null,
    rs_023: null,
    rs_024: null,
    rs_025: null,
    rs_026: null,
    rs_027: null,
    rs_028: null,
    rs_029: null,
    rs_030: null,
    rs_031: null,
    rs_032: null,
    rs_033: null,
    rs_034: null,
    rs_035: null,
    rs_036: null,
    rs_037: null,
    rs_038: null,
    rs_039: null,
    rs_040: null,
    rs_041: null,
    rs_042: null,
    bg_001: null,
    bg_002: null,
    bg_003: null,
    bg_004: null,
    bg_005: null,
    bg_006: null,
    bg_007: null,
    bg_008: null,
    bg_009: null,
    bg_010: null,
    bg_011: null,
    bg_012: null,
    bg_013: null,
    bg_014: null,
    bg_015: null,
    bg_016: null,
    bg_017: null,
    bg_018: null,
    bg_019: null,
    bg_020: null,
    bg_021: null,
    bg_022: null,
    bg_023: null,
    bg_024: null,
    bg_025: null,
    bg_026: null,
    bg_027: null,
    bg_028: null,
    bg_029: null,
    bg_030: null,
    bg_031: null,
    bg_032: null,
    bg_033: null,
    bg_034: null,
    bg_035: null,
    bg_036: null,
    bg_037: null,
    bg_038: null,
    bg_039: null,
    bg_040: null,
    bg_041: null,
    bg_042: null,
    bg_043: null,
    bg_044: null,
    bg_045: null,
    bg_046: null,
    bg_047: null,
    bg_048: null,
    bg_049: null,
    bg_050: null,
    bg_051: null,
    bg_052: null,
    bg_053: null,
    bg_054: null,
    bg_055: null,
    bg_056: null,
    bg_057: null,
    bg_058: null,
    bg_059: null,
    bg_060: null,
    bg_061: null,
    bg_062: null,
    bg_063: null,
    bg_064: null,
    bg_065: null,
    bg_066: null,
    bg_067: null,
    bg_068: null,
    bg_069: null,
    bg_070: null,
    bg_071: null,
    bg_072: null,
    bg_073: null,
    bg_074: null,
    bg_075: null,
    bg_076: null,
    bg_077: null,
    bg_078: null,
    bg_079: null,
    bg_080: null,
    bg_081: null,
    bg_082: null,
    bg_083: null,
    bg_084: null,
    bg_085: null,
    bg_086: null,
    bg_087: null,
    bg_088: null,
    bg_089: null,
    bg_090: null,
    bg_091: null,
    bg_092: null,
    bg_093: null,
    bg_094: null,
    bg_095: null,
    bg_096: null,
    bg_097: null,
    bg_098: null,
    bg_099: null,
    bg_100: null,
    bg_101: null,
    bg_102: null,
    bg_103: null,
    bg_104: null,
    bg_105: null,
    bg_106: null,
    bg_107: null,
    bg_108: null,
    ro_001: null,
    ro_002: null,
    ro_003: null,
    ro_004: null,
    ro_005: null,
    ro_006: null,
    ro_007: null,
    ro_008: null,
    ro_009: null,
    ro_010: null,
    ro_011: null,
    ro_012: null,
    ro_013: null,
    ro_014: null,
    ro_015: null,
    ro_016: null,
    ro_017: null,
    ro_018: null,
    ro_019: null,
    ro_020: null,
    ro_021: null,
    ro_022: null,
    ro_023: null,
    ro_024: null,
    ro_025: null,
    ro_026: null,
    ro_027: null,
    ro_028: null,
    ro_029: null,
    ro_030: null,
    ro_031: null,
    ro_032: null,
    ro_033: null,
    ro_034: null,
    ro_035: null,
    ro_036: null,
    ro_038: null,
    ro_039: null,
    ro_040: null,
    ro_041: null,
    ro_042: null,
    ro_043: null,
    ro_044: null,
    ro_045: null,
    ro_046: null,
    ro_047: null,
    ro_048: null,
    ro_049: null,
    ro_050: null,
    ro_051: null,
    ro_052: null,
    ro_053: null,
    ro_054: null,
    ro_055: null,
    ro_056: null,
    ro_057: null,
    ro_058: null,
    ro_059: null,
    ro_060: null,
    ro_061: null,
    ro_062: null,
    ro_063: null,
    ro_064: null,
    ro_065: null,
    ro_066: null,
    ro_067: null,
    ro_068: null,
    ro_069: null,
    ro_070: null,
    ro_071: null,
    ro_072: null,
    ro_073: null,
    ro_074: null,
    ro_075: null,
    ro_076: null,
    ro_077: null,
    ro_078: null,
    ro_079: null,
    ro_080: null,
    gr_001: null,
    gr_002: null,
    gr_003: null,
    gr_004: null,
    gr_005: null,
    gr_006: null,
    gr_007: null,
    gr_008: null,
    gr_009: null,
    gr_010: null,
    gr_011: null,
    gr_012: null,
    gr_013: null,
    gr_014: null,
    gr_015: null,
    gr_016: null,
    gr_017: null,
    gr_018: null,
    gr_019: null,
    gr_020: null,
    gr_021: null,
    gr_022: null,
    gr_023: null,
    gr_024: null,
    gr_025: null,
    gr_026: null,
    gr_027: null,
    gr_028: null,
    gr_029: null,
    gr_030: null,
    gr_031: null,
    gr_032: null,
    gr_033: null,
    gr_034: null,
    gr_035: null,
    gr_036: null,
    gr_037: null,
    gr_038: null,
    gr_039: null,
    gr_040: null,
    gr_041: null,
    gr_042: null,
    gr_043: null,
    gr_044: null,
    gr_045: null,
    gr_046: null,
    gr_047: null,
    gr_048: null,
    gr_049: null,
    gr_050: null,
    gr_051: null,
    gr_052: null,
    gr_053: null,
    gr_054: null,
    gr_055: null,
    gr_056: null,
    gr_057: null,
    gr_058: null,
    gr_059: null,
    gr_060: null,
    gr_061: null,
    gr_062: null,
    gr_063: null,
    gr_064: null,
    gr_065: null,
    gr_066: null,
    hr_001: null,
    hr_002: null,
    hr_003: null,
    hr_004: null,
    hr_005: null,
    hr_006: null,
    hr_007: null,
    hr_008: null,
    hr_009: null,
    hr_010: null,
    hr_011: null,
    hr_012: null,
    hr_013: null,
    hr_014: null,
    hr_015: null,
    hr_016: null,
    hr_017: null,
    hr_018: null,
    hr_019: null,
    hr_020: null,
    hr_021: null,
    hr_022: null,
    hr_023: null,
    hr_024: null,
    hr_025: null,
    hr_026: null,
    hr_027: null,
    hr_028: null,
    hr_029: null,
    hr_030: null,
    hr_031: null,
    hr_032: null,
    hr_033: null,
    hr_034: null,
    hr_035: null,
    hr_036: null,
    hr_037: null,
    hr_038: null,
    hr_039: null,
    hr_040: null,
    hr_041: null,
    si_001: null,
    si_002: null,
    si_003: null,
    si_004: null,
    si_005: null,
    si_006: null,
    si_007: null,
    si_008: null,
    si_009: null,
    si_010: null,
    si_011: null,
    si_012: null,
    si_013: null,
    si_014: null,
    si_015: null,
    si_016: null,
    si_017: null,
    si_018: null,
    tr_001: null,
    tr_002: null,
    tr_003: null,
    tr_004: null,
    tr_005: null,
    tr_006: null,
    tr_007: null,
    tr_008: null,
    tr_009: null,
    tr_010: null,
    tr_011: null,
    tr_012: null,
    tr_013: null,
    tr_014: null,
    tr_015: null,
    tr_016: null,
    tr_017: null,
    tr_018: null,
    tr_019: null,
    tr_020: null,
    tr_021: null,
    tr_022: null,
    tr_023: null,
    tr_024: null,
    tr_025: null,
    tr_026: null,
    tr_027: null,
    tr_028: null,
    tr_029: null,
    tr_030: null,
    tr_031: null,
    tr_032: null,
    tr_033: null,
    tr_034: null,
    tr_035: null,
    tr_036: null,
    tr_037: null,
    tr_038: null,
    tr_039: null,
    tr_040: null,
    tr_041: null,
    tr_042: null,
    tr_043: null,
    tr_044: null,
    tr_045: null,
    tr_046: null,
    tr_047: null,
    tr_048: null,
    tr_049: null,
    tr_050: null,
    tr_051: null,
    tr_052: null,
    tr_053: null,
    tr_054: null,
    tr_055: null,
    tr_056: null,
    tr_057: null,
    tr_058: null,
    tr_059: null,
    tr_060: null,
    tr_061: null,
    tr_062: null,
    tr_063: null,
    tr_064: null,
    tr_065: null,
    tr_066: null,
    tr_067: null,
    tr_068: null,
    tr_069: null,
    tr_070: null,
    tr_071: null,
    tr_072: null,
    tr_073: null,
    tr_074: null,
    tr_075: null,
    tr_076: null,
    tr_077: null,
    tr_078: null,
    tr_079: null,
    tr_080: null,
    tr_081: null,
    hu_001: null,
    hu_002: null,
    hu_003: null,
    hu_004: null,
    hu_005: null,
    hu_006: null,
    hu_007: null,
    hu_008: null,
    hu_009: null,
    hu_010: null,
    hu_011: null,
    hu_012: null,
    hu_013: null,
    hu_014: null,
    hu_015: null,
    hu_016: null,
    hu_017: null,
    hu_018: null,
    hu_019: null,
    hu_020: null,
    hu_021: null,
    hu_022: null,
    hu_023: null,
    hu_024: null,
    hu_025: null,
    sk_001: null,
    sk_002: null,
    sk_003: null,
    sk_004: null,
    sk_005: null,
    sk_006: null,
    sk_007: null,
    sk_008: null,
    sk_009: null,
    sk_010: null,
    sk_011: null,
    sk_012: null,
    sk_013: null,
    sk_014: null,
    sk_015: null,
    sk_016: null,
    sk_017: null,
    sk_018: null,
    sk_019: null,
    sk_020: null,
    sk_021: null,
    sk_022: null,
    sk_023: null,
    sk_024: null,
    sk_025: null,
    sk_026: null,
    sk_027: null,
    sk_028: null,
    sk_029: null,
    sk_030: null,
    sk_031: null,
    sk_032: null,
    sk_033: null,
    sk_034: null,
    sk_035: null,
    sk_036: null,
    sk_037: null,
    sk_038: null,
    sk_039: null,
    sk_040: null,
    sk_041: null,
    sk_042: null,
    sk_043: null,
    sk_044: null,
    sk_045: null,
    sk_046: null,
    sk_047: null,
    sk_048: null,
    sk_049: null,
    sk_050: null,
    sk_051: null,
    sk_052: null,
    sk_053: null,
    sk_054: null,
    sk_055: null,
    sk_056: null,
    sk_057: null,
    sk_058: null,
    sk_059: null,
    sk_060: null,
    sk_061: null,
    sk_062: null,
    sk_063: null,
    sk_064: null,
    sk_065: null,
    sk_066: null,
    sk_067: null,
    sk_068: null,
    sk_069: null,
    sk_070: null,
    sk_071: null,
    sk_072: null,
    cz_001: null,
    cz_002: null,
    cz_003: null,
    cz_004: null,
    cz_005: null,
    cz_006: null,
    cz_007: null,
    cz_008: null,
    cz_009: null,
    cz_010: null,
    cz_011: null,
    cz_012: null,
    cz_013: null,
    cz_014: null,
    lt_001: null,
    lt_002: null,
    lt_003: null,
    lt_004: null,
    lt_005: null,
    lt_006: null,
    lt_007: null,
    lt_008: null,
    lt_009: null,
    lt_010: null,
    lt_011: null,
    lt_012: null,
    lt_013: null,
    lt_014: null,
    lt_015: null,
    lt_016: null,
    lt_017: null,
    lt_018: null,
    lt_019: null,
    es_001: null,
    es_002: null,
    es_003: null,
    es_004: null,
    es_005: null,
    es_006: null,
    pl_001: null,
    pl_002: null,
    pl_003: null,
    pl_004: null,
    pl_005: null,
    pl_006: null,
    pl_007: null,
    pl_008: null,
    pl_009: null,
    pl_010: null,
    pl_011: null,
    pl_012: null,
    pl_013: null,
    pl_014: null,
    pl_015: null,
    pl_016: null,
    pl_017: null,
    pl_018: null,
  },
  app_sklopovi_a_title: {
    _1_1: "Opekarski šuplji blok",
    _1_2: "Opekarski šuplji blok sa termoizolacijom",
    _1_3: "Blokovi od lakog betona",
    _1_4: "Zid od pune opeke",
    _1_5: "Zid od šuplje opeke (giter) ili bloka",
    _1_6: "Zid od šuplje opeke (giter) ili bloka sa termoizolacijom",
    _1_7: "Zid od armiranog betona",
    _1_8: "Zid od armiranog betona sa termoizolacijom",
    _1_9: "Zid od kamena.",
    _1_10: "Bondruk (drvena konstrukcija sa ispunom)",
    _1_11: "Zid od zemlje (naboj/nabijena zemlja ili ćerpič)",
    _1_12: "Drveni montažni zid",
    _1_13: "Zid od betonskih blokova",
    _1_14: "Troslojni zid: opeka ili blok + vazduh + opeka",
    _1_15: "Troslojni zid: opeka ili blok + termoizolacija + opeka",
    _1_16: "Zid od termobloka",
    _1_17: "Zid od parenog gas betona",
    _1_18: "Zid od parenog gas betona sa termoizolacijom",
    _1_19: "Zid od armiranog betona obložen fasadnom opekom",
    _1_20: "Troslojni zid: armirani beton + termoizolacija + opeka",
    _5_1: "Armirano betonska ploča",
    _5_2: "Armirano betonska sitno rebrasta tavanica",
    _5_3: "Armirano betonska polumontažna tavanica",
    _5_4: "Armirano betonska ploča",
    _5_5: "Armirano betonska ploča",
    _5_6: "Ploča od lakog betona",
    _7_1: "Kosa armirano betonska ploča",
    _7_2: "Kosa armirano betonska polumontažna tavanica",
    _7_3: "Kosa drvena konstrukcija",
    _7_4: "Kosa drvena konstrukcija, delimično  termički izolovana",
    _7_5: "Kosa drvena konstrukcija termički izolovana",
    _7_6: "Kosa armirano betonska ploča termički izolovana",
    _10_1: "Drveni sa jednostrukim staklom",
    _10_2: "Metalni sa jednostrukim staklom",
    _10_3: "PVC sa jednostrukim staklom",
    _10_4: "Drveni sa razdvojenim krilima",
    _10_5: "Drveni sa spojenim krilima",
    _10_6: "Drveni jednostruki sa dvostrukim staklom",
    _10_7: "Drveni sa dvoslojnim staklo paketom",
    _10_8: "Drveni sa dvoslojnim staklo paketom",
    _10_9: "Drveni sa troslojnim staklo paketom",
    _10_10: "Drveni sa niskoemisionim dvoslojnim staklo paketom",
    _10_11: "Drveni sa niskoemisionim dvoslojnim staklo paketom sa kriptonom",
    _10_12: "PVC petokomorni sa dvoslojnim staklo paketom",
    _10_13: "PVC petokomorni sa dvoslojnim staklo paketom",
    _10_14: "PVC šestokomorni sa niskoemisionim dvoslojnim staklo paketom",
    _10_15: "PVC šestokomorni sa niskoemisionim dvoslojnim staklo paketom sa kriptonom",
    _10_16: "PVC šestokomorni sa niskoemisionim troslojnim staklo paketom sa kriptonom",
    _10_17: "Aluminijumski ram sa termičkim prekidom",
    _10_18: "Aluminijumski ram sa termičkim prekidom",
    _10_19: "Aluminijumski ram sa termičkim prekidom",
    _10_20: "Aluminijumski ram sa termičkim prekidom",
    _10_21: "Aluminijumski ram sa poboljšanim termičkim prekidom",
    _10_22: "Aluminijumski ram sa poboljšanim termičkim prekidom",
    _10_23: "Metalni (bez termoprekida) sa dvostrukim staklom",
    _10_24: "Metalni (bez termoprekida) sa dvostrukim staklom",
    _10_25: "Double glazed low -e, synthetic frame",
    _10_26: "Double glazed low -e, synthetic frame",
    _10_27: "Double glazed low -e, synthetic frame",
    _10_28: "Double glazed low -e, synthetic frame",
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: "Vrata drvena puna",
    _13_2: "Vrata drvena izolovana",
    _13_3: "Vrata metalna neizolovana",
    _13_4: "Vrata metalna izolovana",
    _13_5: "Vrata drvena sa ispunom od stakla",
    _13_6: "Vrata metalna, zastakljena",
    _13_7: "PVC vrata",
    _13_8: "Sigurnosna vrata",
    _13_9: "missing",
    _18_1: "Puna armirano betonska ploča",
    _18_2: "Armirano betonska sitno rebrasta konstrukcija",
    _18_3: "Armirano betonska polumotažna konstrukcija",
    _18_4: "Drvena konstrukcija",
    _18_5: "Drvena konstrukcija",
    _18_6: "Drvena konstrukcija",
    _18_7: "Puna armirano betonska ploča",
    _18_8: "Armirano betonska polumotažna konstrukcija",
    _18_9: "missing",
    _18_101: "Puna armirano betonska ploča",
    _18_102: "Armirano betonska sitno rebrasta konstrukcija",
    _18_103: "Armirano betonska polumotažna konstrukcija",
    _18_104: "Drvena konstrukcija",
    _18_105: "Drvena konstrukcija",
    _18_106: "Drvena konstrukcija",
    _18_107: "Puna armirano betonska ploča",
    _18_108: "Armirano betonska polumotažna konstrukcija",
    _18_109: "missing",
    _19_1: "Puna armirano betonska ploča",
    _19_2: "Armirano betonska sitno rebrasta konstrukcija",
    _19_3: "Armirano betonska sitno rebrasta konstrukcija",
    _19_4: "Armirano betonska polumontažna konstrukcija",
    _19_5: "Drvena konstrukcija (rebra)",
    _19_6: "Drvena konstrukcija (rebra)",
    _19_7: "„Pruski svod“ – svod od pune opeke",
    _19_8: "Svod od pune opeke",
    _19_9: "Puna armirano betonska ploča",
    _19_10: "Armirano betonska polumontažna konstrukcija",
    _19_11: "Puna armirano betonska ploča",
    _20_1: "Podrumski zid od kamena",
    _20_2: "Podrumski zid od pune opeke",
    _20_3: "Armiranobetonski podrumski zid",
    _20_4: "Armiranobetonski podrumski zid",
    _21_1: "Pod od nabijene zemlje",
    _21_2: "Pod (sve vrste) – neizolovan",
    _21_3: "Pod (sve vrste) – neizolovan",
    _21_4: "Pod (sve vrste) preko betonske podloge",
  },
  app_sklopovi_a_select: {
    _1_1: "Opekarski šuplji blok, bez termoizolacije, obostrano malterisan",
    _1_2: "Opekarski šuplji blok sa spoljašnje strane postoji odredjena (nedovoljna) termoizolacija, obostrano malterisano.",
    _1_3: "Blokovi od lakog betona, bez termoizolacije, obostrano malterisani",
    _1_4: "Zid od pune opeke, bez termoizolacije obostrano malterisan.",
    _1_5: "Zid od ošupljene (giter) opeke ili bloka, bez termoizolacije, obostrano malterisan.",
    _1_6: "Zid od ošupljene (giter) opeke ili bloka, sa spoljašnje strane postoji odredjena (nedovoljna) termoizolacija, obostrano malterisano.",
    _1_7: "Zid od armiranog betona, bez termoizolacije, obostrano malterisan",
    _1_8: "Zid od armiranog betona, sa odredjenom (nedovoljnom) termoizolacijom, obostrano malterisan",
    _1_9: "Zid od kamena.",
    _1_10: "Bondruk (drvena konstrukcija sa ispunom)",
    _1_11: "Zid od zemlje (naboj/nabijena zemlja ili ćerpič)",
    _1_12: "Zid od drvenih talpi",
    _1_13: "Zid od betonskih blokova, obostrano malterisan",
    _1_14: "Troslojni zid od ošupljene (giter) opeke ili bloka, obložen fasadnom opekom sa vazdušnim međuslojem",
    _1_15:
      "Troslojni zid od ošupljene (giter) opeke ili bloka, obložen fasadnom opekom, sa međuslojem od termoizolacije",
    _1_16: "Zid od termobloka, obostrano malterisan",
    _1_17: "Zid od parenog gas betona, bez izolacije, obostrano malterisan",
    _1_18: "Zid od parenog gas betona sa termoizolacijom",
    _1_19: "Zid od armiranog betona, omalterisan sa unutrašnje strane, spolja obložen fasadnom opekom",
    _1_20: "Troslojni zid od armiranog betona, obložen fasadnom opekom, sa međuslojem od termoizolacije",
    _5_1: "Armirano betonska ploča, bez termoizolacije, spoljašnja hidroizolacija i mehanička zaštita",
    _5_2: "Armirano betonska sitno rebrasta tavanica. Sa donje strane plafon (malter preko trske i letvi). Sa gornje strane hidroizolacija i slojevi mehaničke zaštite. Nema termoizolacije.",
    _5_3: "Armirano betonska polumontažna tavanica, sa opekarskim blokovima ispune. Sa gornje strane hidroizolacija i slojevi mehaničke zaštite. Nema termoizolacije.",
    _5_4: "Armirano betonska ploča, sa termoizolacijom, spoljašnja hidroizolacija i mehanička zaštita",
    _5_5: "Armirano betonska ploča, sa termoizolacijom i ventiliranim slojem; spoljašnja hidroizolacija i mehanička zaštita",
    _5_6: "Ploča od lakog betona ploča, bez termoizolacije; spoljašnja hidroizolacija i mehanička zaštita",
    _7_1: "Kosa armirano betonska ploča, bez termoizolacije. Sa spoljne strane krovni pokrivač na drvenoj podkonstrukciji, sa rezervnom hidroizolacijom.",
    _7_2: "Kosa armirano betonska polumontažna tavanica, sa opekarskim blokovima ispune.\r\nSa spoljne strane krovni pokrivač na drvenoj podkonstrukciji, sa rezervnom hidroizolacijom.",
    _7_3: "Kosa drvena konstrukcija, bez termoizolacije. Sa spoljne strane krovni pokrivač na drvenoj podkonstrukciji, sa rezervnom hidroizolacijom.",
    _7_4: "Kosa drvena konstrukcija, sa delimičnom termoizolacijom između rogova.\r\nSa spoljne strane krovni pokrivač na drvenoj podkonstrukciji, sa rezervnom hidroizolacijom.",
    _7_5: "Kosa drvena konstrukcija, sa termoizolacijom između rogova u punoj visini drvene konstrukcije.\r\nSa spoljne strane krovni pokrivač na drvenoj podkonstrukciji, sa rezervnom hidroizolacijom.",
    _7_6: "Kosa armirano betonska ploča, sa termoizolacijom.\r\nSa spoljne strane krovni pokrivač na drvenoj podkonstrukciji, sa rezervnom hidroizolacijom.",
    _10_1: "Drveni sa jednostrukim staklom",
    _10_2: "Metalni sa jednostrukim staklom",
    _10_3: "PVC sa jednostrukim staklom",
    _10_4: "Drveni sa razdvojenim krilima",
    _10_5: "Drveni sa spojenim krilima",
    _10_6: "Drveni jednostruki sa dvostrukim staklom",
    _10_7: "Drveni sa dvoslojnim staklo paketom 4+12+4",
    _10_8: "Drveni sa dvoslojnim staklo paketom 6+12+6",
    _10_9: "Drveni sa troslojnim staklo paketom 6+12+6+12+6",
    _10_10: "Drveni sa niskoemisionim dvoslojnim staklo paketom 4+12+4",
    _10_11: "Drveni sa niskoemisionim dvoslojnim staklo paketom sa kriptonom 4+12+4",
    _10_12: "PVC petokomorni sa dvoslojnim staklo paketom 4+12+4",
    _10_13: "PVC petokomorni sa dvoslojnim staklo paketom 6+12+6",
    _10_14: "PVC šestokomorni sa niskoemisionim dvoslojnim staklo paketom 4+12+4",
    _10_15: "PVC šestokomorni sa niskoemisionim dvoslojnim staklo paketom sa kriptonom 4+12+4",
    _10_16: "PVC šestokomorni sa niskoemisionim troslojnim staklo paketom sa kriptonom 4+8+4+8+4",
    _10_17: "Aluminijumski ram sa termičkim prekidom , dvoslojni staklo paket 4+12+4",
    _10_18: "Aluminijumski ram sa termičkim prekidom , dvoslojni staklo paket 6+16+6",
    _10_19: "Aluminijumski ram sa termičkim prekidom , troslojni staklo paket 6+12+6+12+6",
    _10_20: "Aluminijumski ram sa termičkim prekidom , niskoemisioni dvoslojni staklo paket 4+12+4",
    _10_21:
      "Aluminijumski ram sa poboljšanim termičkim prekidom , niskoemisioni dvoslojni staklo paket sa kriptonom 4+12+4",
    _10_22:
      "Aluminijumski ram sa poboljšanim termičkim prekidom , niskoemisioni troslojni staklo paket sa kriptonom 6+16+6+16+6",
    _10_23: "Metalni (bez termoprekida) sa dvostrukim staklom (6mm)",
    _10_24: "Metalni (bez termoprekida) sa dvostrukim staklom (12mm)",
    _10_25: "Double glazed low -e, synthetic frame, according to KENAK (Zone A)",
    _10_26: "Double glazed low -e, synthetic frame, according to KENAK (Zone B)",
    _10_27: "Double glazed low -e, synthetic frame, according to KENAK (Zone C)",
    _10_28: "Double glazed low -e, synthetic frame, according to KENAK (Zone D)",
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: "Vrata drvena puna",
    _13_2: "Vrata drvena izolovana",
    _13_3: "Vrata metalna neizolovana",
    _13_4: "Vrata metalna izolovana",
    _13_5: "Vrata drvena sa ispunom od stakla",
    _13_6: "Vrata metalna, zastakljena",
    _13_7: "PVC vrata",
    _13_8: "Sigurnosna vrata",
    _18_1: "Puna armirano betonska ploča, bez termoizolacije, malterisana sa donje strane.",
    _18_2: "Armirano betonska sitno rebrasta konstrukcija, sa donje strane plafon (malter preko trske i letvi)",
    _18_3:
      "Armirano betonska polumotažna konstrukcija, sa opekarskim blokovima ispune, bez termoizolacije, malterisana sa donje strane.",
    _18_4: "Drvena konstrukcija, rebra, podašćana odozgo, sa nasipom (karatavan), bez plafona",
    _18_5:
      "Drvena konstrukcija, drvena rebra, podašćana odozgo, sa nasipom (karatavan), sa donje strane plafon, malter preko trske i letava.",
    _18_6:
      "Drvena konstrukcija, drvena rebra, podaščana odozgo, sa donje strane plafon, malter preko trske i letava; međuprostor između rebara delimično ispunjen termoizolacijom",
    _18_7: "Puna armirano betonska ploča, sa termoizolacijom sa gornje strane, malterisana sa donje strane.",
    _18_8:
      "Armirano betonska polumotažna konstrukcija, sa opekarskim blokovima ispune, sa termoizolacijom sa gornje strane, malterisana sa donje strane.",
    _18_9: "missing",
    _18_101: "Puna armirano betonska ploča, bez termoizolacije, malterisana sa donje strane.",
    _18_102: "Armirano betonska sitno rebrasta konstrukcija, sa donje strane plafon (malter preko trske i letvi)",
    _18_103:
      "Armirano betonska polumotažna konstrukcija, sa opekarskim blokovima ispune, bez termoizolacije, malterisana sa donje strane.",
    _18_104: "Drvena konstrukcija, rebra, podašćana odozgo, sa nasipom (karatavan), bez plafona",
    _18_105:
      "Drvena konstrukcija, drvena rebra, podašćana odozgo, sa nasipom (karatavan), sa donje strane plafon, malter preko trske i letava.",
    _18_106:
      "Drvena konstrukcija, drvena rebra, podaščana odozgo, sa donje strane plafon, malter preko trske i letava; međuprostor između rebara delimično ispunjen termoizolacijom",
    _18_107: "Puna armirano betonska ploča, sa termoizolacijom sa gornje strane, malterisana sa donje strane.",
    _18_108:
      "Armirano betonska polumotažna konstrukcija, sa opekarskim blokovima ispune, sa termoizolacijom sa gornje strane, malterisana sa donje strane.",
    _18_109: "missing",
    _19_1: "Puna armirano betonska ploča, bez termozolacije. Sa gornje strane podna obloga na podkonstrukciji (estrih)",
    _19_2:
      "Armirano betonska sitno rebrasta konstrukcija, bez termoizolacije. Sa donje (podrumske) strane ne postoji plafon. Sa gornje strane podna obloga na podkonstrukciji (estrih)",
    _19_3:
      "Armirano betonska sitno rebrasta konstrukcija, bez termoizolacije. Sa donje (podrumske) strane postoji plafon (malter preko trske i letvi). Sa gornje strane podna obloga na podkonstrukciji (estrih)",
    _19_4:
      "Armirano betnnska polumontažna konstrukcija sa opekarskim blokovima ispune, bez termoizolacije. Sa gornje strane podna obloga na podkonstrukciji (estrih).",
    _19_5:
      "Drvena konstrukcija (rebra), oplaćene daskom, sa nasipom, podpatosnicama, slepim podom i podnom oblogom. Sa donje strane (podrumske) nema plafona",
    _19_6:
      "Drvena konstrukcija (rebra), oplaćene daskom, sa nasipom, podpatosnicama, slepim podom i podnom oblogom. Sa donje strane (podrumske) plafon: malterisana trska preko letvi.",
    _19_7:
      "„Pruski svod“ – svod od pune opeke, na čeličnim nosačima, nasip sa gornje strane, potpatosnice i patos sa podnom oblogom. Sa donje strane nema plafona",
    _19_8:
      "Svod od pune opeke, nasip sa gornje strane, potpatosnice i patos sa podnom oblogom.\r\nSa donje strane nema plafona",
    _19_9:
      "Puna armirano betonska ploča, sa termozolacijom u sloju poda. Sa gornje strane podna obloga na podkonstrukciji (estrih)",
    _19_10:
      "Armirano betonska polumontažna konstrukcija sa opekarskim blokovima ispune, sa termozolacijom u sloju poda. Sa gornje strane podna obloga na podkonstrukciji (estrih).",
    _19_11:
      "Puna armirano betonska ploča, sa termozolacijom u sloju poda. Sa gornje strane podna obloga na podkonstrukciji (estrih). Sa donje strane ploče dodatni sloj termoizolacije.",
    _20_1: "Podrumski zid od kamena, bez termičke izolacije",
    _20_2: "Podrumski zid od kamena, bez termičke izolacije",
    _20_3: "Armiranobetonski podrumski zid, bez termičke izolacije",
    _20_4: "Armiranobetonski podrumski zid, sa termičkom izolacijom",
    _21_1: "Pod od nabijene zemlje",
    _21_2: "Pod (sve vrste) – neizolovan, preko podloge od nabijene zemlje",
    _21_3: "Pod (sve vrste) – neizolovan, preko betonske podloge",
    _21_4: "Pod (sve vrste) preko betonske podloge, termički izolovan",
  },
  app_sklopovi_b_select: {
    _1_1: "Postavljanje termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_2: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_3: "Postavljanje termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_4: "Postavljanje termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_5: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_6: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_7: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_8: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu, sa lepljenim fasadnim pločicama",
    _1_9: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu, sa lepljenim fasadnim pločicama",
    _1_10: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_11: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_12: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_13: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_14: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_15: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_16: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_17: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_18: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_19: "Postavljanje  termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _1_20: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa spoljašnje strane u ETICS sistemu",
    _5_1: "Rušenje postojećih spoljašnjih slojeva ravnog krova, izrada parozaštitne membrane, termoizolacije od kamene mineralne vune, hidroizolacije i slojeva mehaničke zaštite.",
    _5_2: "Rušenje postojećih spoljašnjih slojeva ravnog krova, izrada parozaštitne membrane, termoizolacije od kamene mineralne vune, hidroizolacije i slojeva mehaničke zaštite.",
    _5_3: "Rušenje postojećih spoljašnjih slojeva ravnog krova, izrada parozaštitne membrane, termoizolacije od kamene mineralne vune, hidroizolacije i slojeva mehaničke zaštite.",
    _5_4: "Rušenje postojećih spoljašnjih slojeva ravnog krova, izrada parozaštitne membrane, termoizolacije od kamene mineralne vune, hidroizolacije i slojeva mehaničke zaštite.",
    _5_5: "Rušenje postojećih spoljašnjih slojeva ravnog krova, izrada parozaštitne membrane, termoizolacije od kamene mineralne vune, hidroizolacije i slojeva mehaničke zaštite.",
    _5_6: "Rušenje postojećih spoljašnjih slojeva ravnog krova, izrada parozaštitne membrane, termoizolacije od kamene mineralne vune, hidroizolacije i slojeva mehaničke zaštite.",
    _7_1: "Skidanje postojećeg krovnog pokrivača i podkonstrukcije.Postavljanje parozaštne mebrane, drvene podkonstrukcije sa termoizolacijom od mineralne vune, podaščavanje, izrada rezervne kišne brane i pokrivača na podkonstrukciji.",
    _7_2: "Skidanje postojećeg krovnog pokrivača i podkonstrukcije.\r\nPostavljanje parozaštne mebrane, drvene podkonstrukcije sa termoizolacijom od mineralne vune, podaščavanje, izrada rezervne kišne brane i pokrivača na podkonstrukciji.",
    _7_3: "Skidanje postojećeg krovnog pokrivača i postavljanje mineralne vune preko podaščanja, izrada kišne brane i pokrivača na podkonstrukciji.",
    _7_4: "Dodavanje termoizolacije od mineralne vune izmedju rogova. Oblaganje plafona gips karton pločama ili drvenom lamperijom, preko parozaštitne membrane.  U slučaju nedovoljne debljine izolacije, skidanje postojećeg krovnog pokrivača i podkonstrukcije, nadvišavanje rogova i dodavanje termoizolacije od mineralne vune, podaščavanje, izrada rezervne kišne brane i pokrivača na podkonstrukciji.",
    _7_5: "Skidanje postojećeg krovnog pokrivača i podkonstrukcije, nadvišavanje rogova i dodavanje termoizolacije od mineralne vune, podaščavanje, izrada rezervne kišne brane i pokrivača na podkonstrukciji.",
    _7_6: "Skidanje postojećeg krovnog pokrivača, podkonstrukcije i izolacije, nadvišavanje podkonstrukcije u sloju termoizolacije i ispunjavanje cele visine termoizolacijom od mineralne vune, izrada kišne brane i pokrivača na podkonstrukciji.",
    _10_1: null,
    _10_2: null,
    _10_3: null,
    _10_4: null,
    _10_5: null,
    _10_6: null,
    _10_7: null,
    _10_8: null,
    _10_9: null,
    _10_10: null,
    _10_11: null,
    _10_12: null,
    _10_13: null,
    _10_14: null,
    _10_15: null,
    _10_16: null,
    _10_17: null,
    _10_18: null,
    _10_19: null,
    _10_20: null,
    _10_21: null,
    _10_22: null,
    _10_23: null,
    _10_24: null,
    _10_25: null,
    _10_26: null,
    _10_27: null,
    _10_28: null,
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: null,
    _13_2: null,
    _13_3: null,
    _13_4: null,
    _13_5: null,
    _13_6: null,
    _13_7: null,
    _13_8: null,
    _18_1:
      "Postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane.\r\nIzrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_2:
      "Postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane.\r\nIzrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_3:
      "Postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane.\r\nIzrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_4:
      "Uklanjanje nasipa i postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_5:
      "Uklanjanje nasipa I postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_6:
      "Uklanjanje nasipa I postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_7:
      "Dodavanje drugog sloja termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_8:
      "Dodavanje drugog sloja termoizolacije od mineralne vune sa gornje (tavanske) strane, preko sloja postojeće termoizolacije i parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_9: "missing",
    _18_101:
      "Postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane.\r\nIzrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_102:
      "Postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane.\r\nIzrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_103:
      "Postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane.\r\nIzrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_104:
      "Uklanjanje nasipa i postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_105:
      "Uklanjanje nasipa I postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_106:
      "Uklanjanje nasipa I postavljanje termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_107:
      "Dodavanje drugog sloja termoizolacije od mineralne vune sa gornje (tavanske) strane, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_108:
      "Dodavanje drugog sloja termoizolacije od mineralne vune sa gornje (tavanske) strane, preko sloja postojeće termoizolacije i parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije, ili druga mehanička zaštita",
    _18_109: "missing",
    _19_1:
      "Uklanjanje postojeće podne obloge. Postavljanje termoizolacije od mineralne vune sa gornje strane konstrukcije, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_2:
      "Uklanjanje postojeće podne obloge. Postavljanje termoizolacije od mineralne vune sa gornje strane konstrukcije, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_3:
      "Uklanjanje postojeće podne obloge. Postavljanje termoizolacije od mineralne vune sa gornje strane konstrukcije, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_4:
      "Uklanjanje postojeće podne obloge. Postavljanje termoizolacije od mineralne vune sa gornje strane konstrukcije, preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_5:
      "Uklanjanje postojeće podne obloge i nasipa sa podpatosnicama. Postavljanje termoizolacije od mineralne vune preko postojećeg slepog pod i preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_6:
      "Uklanjanje postojeće podne obloge i nasipa sa podpatosnicama. Postavljanje termoizolacije od mineralne vune preko postojećeg slepog poda i preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_7:
      "Uklanjanje postojeće podne obloge i nasipa sa podpatosnicama. Postavljanje termoizolacije od mineralne vune preko novog sloja  nasipa od perlitnog maltera i preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_8:
      "Uklanjanje postojeće podne obloge i nasipa sa podpatosnicama. Postavljanje termoizolacije od mineralne vune preko novog sloja  nasipa od perlitnog maltera i preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_9:
      "Uklanjanje postojeće podne obloge. Postavljanje termoizolacije od mineralne vune preko postojećeg estriha i preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_10:
      "Uklanjanje postojeće podne obloge. Postavljanje termoizolacije od mineralne vune preko postojećeg estriha i preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _19_11:
      "Uklanjanje postojeće podne obloge. Postavljanje termoizolacije od mineralne vune preko postojećeg estriha i preko parozaštitne membrane. Izrada plivajućeg poda (estrih) preko zaštitne folije i nove podne obloge.",
    _20_1: null,
    _20_2: null,
    _20_3: null,
    _20_4: null,
    _21_1: null,
    _21_2: null,
    _21_3: null,
    _21_4: null,
  },
  app_sklopovi_c_select: {
    _1_1: "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_2: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_3: "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_4: "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_5: "Postavljanje  termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_6: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_7: "Postavljanje  termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_8: "Postavljanje dodatne termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_9: "Postavljanje  termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_10:
      "Postavljanje dodatne termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_11:
      "Postavljanje  termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_12:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_13:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_14:
      "Postavljanje  termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_15:
      "Postavljanje dodatne termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_16:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_17:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_18:
      "Postavljanje dodatne termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_19:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _1_20:
      "Postavljanje dodatne termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _5_1: "Postavljanje spuštenog plafona sa metalnom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune",
    _5_2: "Rušenje postojećeg plafona. Postavljanje spuštenog plafona sa metalnom ili drvenom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune izmedju rebara",
    _5_3: "Postavljanje spuštenog plafona sa metalnom ili drvenom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune",
    _5_4: "Postavljanje spuštenog plafona sa metalnom ili drvenom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune",
    _5_5: "Postavljanje spuštenog plafona sa metalnom ili drvenom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune",
    _5_6: "Postavljanje spuštenog plafona sa metalnom ili drvenom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune",
    _7_1: "Postavljanje spuštenog plafona sa metalnom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune.",
    _7_2: "Postavljanje spuštenog plafona sa metalnom ili drvenom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune.",
    _7_3: "Postavljanje termoizolacije od mineralne vune, jedan sloj izmedju rogova, drugi sloj ispod rogova, u spuštenom plafonu od gips karton ploča na metalnoj podkonstrukciji, sa parozaštitnom membranom.",
    _7_4: "Dodavanje termoizolacije od mineralne vune između rogova do pune visine drvene konstrukcije. Dodavanje drugog sloja termoizolacije ispod rogova, u spuštenom plafonu od gips karton ploča na metalnoj podkonstrukciji, sa parozaštitnom membranom.",
    _7_5: "Dodavanje drugog sloja termoizolacije ispod rogova, u spuštenom plafonu od gips karton ploča na metalnoj podkonstrukciji, sa parozaštitnom membranom.",
    _7_6: "Postavljanje spuštenog plafona sa metalnom ili drvenom podkonstrukcijom, obloženog gips karton pločama u enterijeru, sa parozaštitnom membranom i termoizolacijom od mineralne vune.",
    _10_1: null,
    _10_2: null,
    _10_3: null,
    _10_4: null,
    _10_5: null,
    _10_6: null,
    _10_7: null,
    _10_8: null,
    _10_9: null,
    _10_10: null,
    _10_11: null,
    _10_12: null,
    _10_13: null,
    _10_14: null,
    _10_15: null,
    _10_16: null,
    _10_17: null,
    _10_18: null,
    _10_19: null,
    _10_20: null,
    _10_21: null,
    _10_22: null,
    _10_23: null,
    _10_24: null,
    _10_25: null,
    _10_26: null,
    _10_27: null,
    _10_28: null,
    _10_29: null,
    _10_30: null,
    _10_31: null,
    _10_32: null,
    _13_1: null,
    _13_2: null,
    _13_3: null,
    _13_4: null,
    _13_5: null,
    _13_6: null,
    _13_7: null,
    _13_8: null,
    _18_1:
      "Izrada spuštenog plafona od gips karton ploča i parozaštitne membrane preko metalne podkonstrukcije, sa termoizolacijom od mineralne vune izmedju rebara.",
    _18_2:
      "Izrada spuštenog plafona od gips karton ploča i parozaštitne membrane preko metalne podkonstrukcije, sa termoizolacijom od mineralne vune izmedju rebara.",
    _18_3:
      "Rušenje postojećeg plafona i izrada spuštenog plafona od gips karton ploča i parozaštitne membrane preko metalne podkonstrukcije, sa termoizolacijom od mineralne vune izmedju rebara.",
    _18_4:
      "Izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_5:
      "Rušenje postojećeg plafona i izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_6:
      "Rušenje postojećeg plafona i izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_7:
      "Izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_8:
      "Izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_9: "missing",
    _18_101:
      "Izrada spuštenog plafona od gips karton ploča i parozaštitne membrane preko metalne podkonstrukcije, sa termoizolacijom od mineralne vune izmedju rebara.",
    _18_102:
      "Izrada spuštenog plafona od gips karton ploča i parozaštitne membrane preko metalne podkonstrukcije, sa termoizolacijom od mineralne vune izmedju rebara.",
    _18_103:
      "Rušenje postojećeg plafona i izrada spuštenog plafona od gips karton ploča i parozaštitne membrane preko metalne podkonstrukcije, sa termoizolacijom od mineralne vune izmedju rebara.",
    _18_104:
      "Izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_105:
      "Rušenje postojećeg plafona i izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_106:
      "Rušenje postojećeg plafona i izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_107:
      "Izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_108:
      "Izrada spuštenog plafona od gips kartona ili drveta, preko metalne ili drvene podkonstrukcije, postavljanje parozaštitne membrane i termoizolacije od mineralne vune izmedju rebara.",
    _18_109: "missing",
    _19_1:
      "Izrada spuštenog plafona sa donje (podrumske) strane od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _19_2:
      "Izrada spuštenog plafona sa donje (podrumske) strane od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune izmedju rebara.",
    _19_3:
      "Rušenje postojećeg plafona sa podrumske strane i Izrada novog, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune izmedju rebara.",
    _19_4:
      "Izrada novog spuštenog plafona sa podrumske strane, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _19_5:
      "Izrada novog spuštenog plafona sa podrumske strane, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _19_6:
      "Rušenje postojećeg i izrada novog spuštenog plafona sa donje podrumske strane, od gips karton ploča preko drvene ili metalne podkonstrukcije, sa termoizolacijom od mineralne vune izmedju drvenih rebara.",
    _19_7:
      "Izrada novog spuštenog plafona sa podrumske strane, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _19_8:
      "Izrada novog spuštenog plafona sa podrumske strane, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _19_9:
      "Izrada novog spuštenog plafona sa podrumske strane, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _19_10:
      "Izrada novog spuštenog plafona sa podrumske strane, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _19_11:
      "Izrada novog spuštenog plafona sa podrumske strane, od gips karton ploča na metalnoj podkonstrukciji, sa termoizolacijom od mineralne vune.",
    _20_1:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _20_2:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _20_3:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _20_4:
      "Postavljanje termoizolacije od kamene mineralne vune sa unutrašnje strane, ispod gips karton ploča na metalnoj podkonstrukciji",
    _21_1:
      "Rušenje postojeće podne obloge i podkonstrukcije. Izrada podne hidroizolacije, termoizolacije od kamene vune, membrane za zaštitu, estriha i podne obloge od keramike.",
    _21_2:
      "Rušenje postojeće podne obloge i podkonstrukcije. Izrada podne hidroizolacije, termoizolacije od kamene vune, membrane za zaštitu, estriha i podne obloge od drveta.",
    _21_3:
      "Rušenje postojeće podne obloge i podkonstrukcije. Izrada podne hidroizolacije, termoizolacije od kamene vune, membrane za zaštitu, estriha i podne obloge od drveta.",
    _21_4:
      "Rušenje postojeće podne obloge, podkonstrukcije i termoizolacije. Izrada podne hidroizolacije, termoizolacije od kamene vune, membrane za zaštitu, estriha i podne obloge od drveta.",
  },
  app_materijali_title: {
    1: "NaturBoard FIT PLUS",
    2: "NaturBoard FIT-G PLUS",
    3: "DF",
    4: "FKD-S Thermal",
    5: "FKD-N Thermal",
    6: "SmartRoof Thermal",
    7: "SmartRoof Thermal 2",
    8: "SmartRoof Top",
    9: "Unifit 035",
    10: "Homeseal LDS 0.02",
    11: "Homeseal LDS 5",
    12: "Homeseal LDS 35",
    13: "NaturBoard POD PLUS",
    14: "NaturBoard POD EXTRA",
    15: null,
    16: null,
    17: null,
    18: null,
    19: null,
    20: null,
    21: null,
    22: null,
    23: null,
    24: null,
    25: null,
    26: null,
    27: null,
    28: null,
    29: null,
    30: null,
    31: null,
    32: null,
    33: null,
    34: null,
    35: null,
    36: null,
    37: null,
    38: null,
    39: null,
    40: null,
    41: null,
    42: null,
    43: null,
    44: null,
    45: null,
    46: null,
    47: null,
    48: null,
    49: null,
    50: null,
    51: null,
    52: null,
    53: null,
    54: null,
    55: null,
    56: null,
    57: null,
    58: null,
    59: null,
    60: null,
    61: null,
    62: null,
    63: null,
    64: null,
    65: null,
    66: null,
    67: null,
    68: null,
    69: null,
    70: null,
    71: null,
    72: null,
    73: null,
    74: null,
    75: null,
    76: null,
    77: null,
    78: null,
    79: null,
    80: null,
    81: null,
    82: null,
    83: null,
    84: null,
    85: null,
    86: null,
    87: null,
    88: null,
    89: null,
    90: null,
    91: null,
    92: null,
    93: null,
    94: null,
    95: null,
    96: null,
    97: null,
    98: null,
    99: null,
    100: null,
    101: null,
    102: null,
    103: null,
    104: null,
    105: null,
    106: null,
    107: null,
    108: null,
    109: null,
    110: null,
    111: null,
    112: null,
    113: null,
    114: null,
    115: null,
    116: null,
    117: null,
    118: null,
    119: null,
    120: null,
    121: null,
    122: null,
    123: null,
    124: null,
    125: null,
    126: null,
    127: null,
    128: null,
    129: null,
    139: null,
    140: null,
    141: null,
    142: null,
    143: null,
    144: null,
    145: null,
    146: null,
    147: null,
    148: null,
    149: null,
    150: null,
    151: null,
    152: null,
    153: null,
    154: null,
    155: null,
    156: null,
    157: null,
    158: null,
    159: null,
    160: null,
    161: null,
    162: null,
    163: null,
    164: null,
    165: null,
    166: null,
    167: null,
    168: null,
    169: null,
    170: null,
    171: null,
    172: null,
    173: null,
    174: null,
    175: null,
    176: null,
    177: null,
    178: null,
    179: null,
    180: null,
    181: null,
    182: null,
    183: null,
    184: null,
    185: null,
    186: null,
    187: null,
    188: null,
    189: null,
    190: null,
    191: null,
    192: null,
    193: null,
    194: null,
    195: null,
    196: null,
    197: null,
    198: null,
    199: null,
    200: null,
    201: null,
    202: null,
    203: null,
    204: null,
    205: null,
    206: null,
    207: null,
  },
  app_materijali_select: {
    1: null,
    2: null,
  },
  loc_zone_title: "Zona",
  loc_hd_title: "HD (Broj dana grejanja)",
  loc_ta_title: "Ta (Prosečna spoljašnja temperatura u grejnom periodu)",
  loc_hdd_ref_title: "HDD (referentna vrednost)",
  loc_ti_ref_title: "TI (referentna vrednost)",
  loc_hdd_title: "HDD (Broj stepen dana grejanja)",
  loc_internal_title: "Unutrašnja temperatura",
  loc_reference_title: "Referentna temperatura",
  typ_pozicija_select: ["Samostojeća", "U nizu"],
  typ_stanje_title: "Nova kuća",
  pos_nagib_title: "Hip > 45°",
  pos_nagib_select: {
    1: "Manje od 45°",
    2: "Više od 45°",
  },
  pos_standard_select: {
    0: "Nezadovoljavajuće unapređenje",
    1: "Zadovoljavajuće unapređenje",
    2: "Preporučeno unapređenje",
  },
  pos_u_max_options_title: "U max",
  typ_floorarea_title: "Unesite ukupnu grejanu površinu Vaše kuće:",
  app_height_title: "Spratna visina:",
  atc_height_title: "Visina potkrovlja",
  typ_brojfasada_title: "Broj fasada izloženih vetru:",
  typ_constdate_title: "Period gradnje",
  loc_sun_select: ["Izloženo", "Umereno osunčano", "U senci"],
  loc_wind_select: ["Veoma", "Umereno vetrovito", "Zaklonjeno"],
  app_back_title: "Nazad",
  app_next_title: "Dalje",
  app_delete_title: "Obriši",
  app_confirm_title: "Potvrdi",
  app_proceed_title: "Nastavi",
  app_cancel_title: "Odustani",
  app_settings_title: "Podešavanja",
  app_change_settings_title: "Promeni podešavanja",
  app_choose_house_title: "Izaberi svoj tip kuće",
  app_summary_title: "UKUPNO",
  app_cta_title: "ovde će biti neki konkretan poziv",
  app_sprat_title: "sprat",
  app_spratovi_title: "spratovi",
  app_intervention_reset_title: "Ako nastavite, sve intervencije će biti poništene!",
  app_intervention_20_21_reset_title: "Ako nastavite, intervencije na podu u tlu i podrumu će biti poništene!",
  app_intervention_all_reset_title: "Ako nastavite, sve intervencije na prozorima će biti poništene!",
  app_intervention_20_21_all_reset_title:
    "Ako nastavite, sve unete površine prozora i intervencije na podu, na tlu i zidu u tlu će biti poništene!",
  pos_window_select: ["PVC", "Drvo", "Metal"],
  typ_window_delete_title: "Ako nastavite, sve unete površine prozora će biti poništene!",
  typ_data_coerce_title: "Vrednost je izvan dozvoljenih okvira. Automatski će biti podešena na regularnu vrednost.",
  pos_20_21_title:
    "Ako prvo unesete intervenciju Zid u tlu, posle nećete moći da unesete intervenciju Pod na tlu bez brisanja ove intervencije.",
  pos_21_20_start_title: "Rad na intervenciji Pod na tlu će poništiti intervenciju Zid u tlu.",
  pos_21_20_delete_title: "Brisanje intervencije Pod na tlu će takođe obrisati intervenciju Zid u tlu.",
  pos_intervention_reset_title: "Potvrdite brisanje intervencije.",
  app_start_title: "Kliknite na sledeći tab",
  app_finish_title: "Zatraži ponudu",
  loc_select_title: "IZABERITE LOKACIJU VAŠE KUĆE",
  loc_additional_title: "DODATNE OPCIJE",
  loc_calculation_title: "KALKULACIJA",
  typ_select_title: "TIP",
  typ_geometry_title: "Izaberite svoj tip kuće",
  typ_heating_title: "Kako se grejete?",
  app_less_parameters_title: "Manje opcija",
  app_more_parameters_title: "Više opcija",
  pos_heading_title: "POZICIJE NA KUĆI",
  pos_existing_title: "IZABERI POSTOJEĆE STANJE",
  pos_intervention_title: "INTERVENCIJA",
  pos_thickness_title: "Debljina postojeće konstrukcije [cm]",
  pos_insulation_title: "Debljina izolacije [cm]",
  pos_expert_title: "Ekspert mod",
  pos_inside_title: "Izolacija unutra",
  pos_inside_description_title: "Izolacija se postavlja unutra",
  pos_outside_title: "Izolacija spolja",
  pos_outside_description_title: "Izolacija se postavlja spolja",
  pos_u_value_options_title: "U vrednost",
  pos_u_value_low_title: "Nezadovoljavajuće unapređenje",
  pos_u_value_good_title: "Zadovoljavajuće unapređenje",
  list_heading_title: "ŠTA IZOLUJEMO I ČIME?",
  list_existing_title: "Trenutno stanje",
  list_intervention_title: "Izolaciono rešenje",
  calc_calculation_title: "KALKULACIJA",
  calc_existing_title: "Postojeće stanje",
  calc_intervention_title: "Unapređeno stanje",
  calc_heat_title: "Potrošnja energije",
  calc_energy_title: "Energetski razred",
  calc_offer_title: "ZATRAŽITE PONUDU",
  calc_again_title: "Ili izračunajte ponovo",
  calc_consumption_title: "Godišnja potrošnja",
  calc_savings_title: "Godišnja ušteda novca i energije",
  app_privacy_title: "Politika privatnosti",
  app_terms_title: "Uslovi korišćenja",
  app_header_title: "Kalkulator energetske efikasnosti",
  calc_disclaimer_title:
    "Svi novčani iznosi su zasnovani na prosečnim cenama i moguće su varijacije u zavisnosti od toga gde živite i/ili koju vrstu grejanja koristite",
  typ_floornumber_title: "Broj grejanih nivoa - etaža:",
  typ_vrstatla_title: "Vrsta tla:",
  typ_vrstatla_select: ["Glina, nasip", "Pesak, šljunak", "Homogena stena"],
  pos_position_select: {
    1: "Fasadni zid",
    5: "Ravan krov",
    7: "Kos krov",
    10: "Prozori",
    13: "Vrata",
    18: "Plafon ispod negrejanog tavana",
    19: "Pod iznad negrejanog podruma",
    20: "Zid u tlu",
    21: "Pod na tlu",
    60: "Krovni prozori",
  },
  typ_house_title: {
    hahb: "Sa grejanim podrumom i grejanim potkrovljem",
    hanhb: "Sa negrejanim podrumom i grejanim potkrovljem",
    nhahb: "Sa grejanim podrumom i negrejanim tavanom",
    nhanhb: "Sa negrejanim podrumom i negrejanim tavanom",
    pnhb: "Sa ravnim krovom i negrejanim podrumom",
    hat: "Sa grejanim potkrovljem",
    nhat: "Sa negrejanim tavanom",
    pt: "Sa ravnim krovom",
    ao: "Samo potkrovlje",
    phb: "Sa ravnim krovom i grejanim podrumom",
  },
  typ_override_window_title: "Ukupna površina prozora:",
  typ_override_roof_window_title: "Ukupna površina krovnih prozora:",
  typ_dubina_title: "Dubina ukopavanja:",
  typ_grejanje_title: {
    1: "Lož ulje",
    2: "Gas",
    3: "Ugalj",
    4: "Drva",
    5: "Struja",
    6: "Daljinsko grejanje",
    7: "Daljinsko grejanje",
    8: "Toplotna pumpa",
    9: "Pelet",
    10: "Kerozin",
    11: "Briketi od uglja",
    12: "Antracit",
    13: "Lignit",
    14: "Klima uređaj",
    15: "Mazut",
    16: "Propan",
  },
  typ_mobile_carousel_click_title: "Kliknite na ikonicu da biste odabrali",
  typ_desktop_carousel_click_title: "Kliknite na ikonicu da biste odabrali",
  typ_select_house_title: "Unesite podatke o kući",
  pos_description_title: "Potvrdite postojeće stanje svih dole navedenih pozicija i unesite željenu intervenciju",
  pos_intervention_on_title: "Uključite da dodate izolaciju",
  pos_confirm_title: "Potvrdite postojeće stanje",
  pos_confirm_all_title: "Potvrdite sve",
  pos_above_title: "Izolacija iznad",
  pos_below_title: "Izolacija ispod",
  pos_izaberi_stanje_title: "Izaberite vaše postojeće stanje",
  pos_idite_desno_title:
    "Potvrdite postojeće stanje bez intervencije ili aktivirajte INTERVENCIJU, a zatim potvrdite sve.",
  pos_aktiviraj_title: "Kliknite za intervenciju",
  pos_deaktiviraj_title: "Deaktiviraj intervenciju",
  app_additional_options_title: "Dodatne opcije",
  app_back_to_house_title: "Povratak na izbor kuće",
  list_what_isolation_title: "Šta izolujemo i čime",
  list_solution_title: "Izolaciono rešenje",
  list_no_intervention_title: "Zadržano postojeće stanje pozicije",
  list_no_intervention_detail_title: "Zadržano postojeće stanje pozicije na kući!",
  list_no_position_title: "Pozicija nije definisana!",
  list_no_position_detail: "Klikom na plavi marker na modelu kuće odaberite tip pozicije na vašoj kući.",
  calc_savings_desktop_title: "Godišnja ušteda novca i energije",
  calc_heating_desktop_title: "Grejanje",
  pos_new_title: "Novo stanje",
  app_created_title: null,
  app_arhitektura_title: "Arhitektura i Energija",
  app_reserved_title: null,
  typ_house_selection_title: "Unesite podatke o kući",
  typ_house_parameters_title: "Izaberite drugu kuću",
  app_ok_title: "U redu",
  pos_nointervention_info_title:
    "Čak i ako ne želite da intervenišete na nekoj od pozicija, morate da potvrdite postojeće stanje svake pozicije kako bi odabir ušao u krajnju kalkulaciju",
  list_change_title: "Izmeni",
  pos_current_insulation_title: "Debljina trenutne izolacije",
  list_define_position_title: "Definišite poziciju",
  list_add_insulation_title: "Dodajte izolaciju",
  typ_ceiling_select: ["Prohodno", "Neprohodno"],
  typ_ceiling_title: "Tip potkrovlja",
  typ_house_geometry_title: "Unesite parametre za kuću",
  pos_define_positions_title: "Od čega je sagrađena vaša\r\nkuća?",
  pos_define_interventions_title: "Izaberite poziciju za intervenciju",
  pos_postojece_proracun_title: "Proračun postojećeg stanja",
  pos_info_1_title:
    "Kliknite na plavi kružić na\r\nkući levo da detaljnije opišete od čega su sagrađeni delovi Vaše\r\nkuće.",
  pos_info_2_title: "Kada potvrdite postojeće stanje svih pozicija možete da\r\npređete na sledeći korak.",
  pos_info_click_title: "Kliknite na sledeću poziciju na kući",
  pos_info_title_title: "Sada ste definisali od čega je sagrađena Vaša kuća.",
  pos_info_subtitle_1_title:
    "Ako želite\r\nda se vratite i dodatno proverite postojeće stanje ili izvršite neke\r\nizmene, kliknite na zeleni kružić na kući ili na naziv dela kuće\r\ntabeli sa leve strane.",
  pos_info_subtitle_2_title: 'Ako ste završili sa definisanjem, kliknite na dugme "Dalje"',
  calc_title_a_title: "Sjajno!",
  calc_subtitle_a_title: "Vaša kuća je u dobrom stanju.",
  calc_description_a_title: 'Ukoliko želite dodatno da poboljšate stanje vaše kuće kliknite na dugme "Unapredi"',
  calc_title_b_title: "Nije loše.",
  calc_subtitle_b_title: "Moglo bi mnogo bolje!",
  calc_description_b_title: 'Hajde da dodatno unapredimo stanje Vaše kuće klikom na dugme "Unapredi"',
  calc_title_c_title: "Nije dobro!",
  calc_subtitle_c_title: "Vaša kuća troši previše!",
  calc_description_c_title: 'Hajde da unapredimo stanje Vaše kuće klikom na dugme "Unapredi"',
  calc_confirm_title: "Unapredi",
  calc_year_title: "GODIŠNJA potrošnja NOVCA I ENERGIJE",
  calc_class_title: "Energetska klasa*",
  calc_uporedno_title: "Uporedno stanje godišnje potrošnje",
  calc_advanced_title: "Unapređeno stanje",
  pos_intervention_start_title: "Kliknite na poziciju na kući na kojoj želite da unapredite stanje.",
  pos_intervention_back_title: "Zadržite postojeće stanje.",
  list_materijal_confirm_title: "Potvrdi poziciju",
  list_more_title: "Želite da unapredite još neku poziciju na kući?",
  list_more_yes_title: "Da, želim",
  list_more_no_title: "Ne želim",
  list_final_top_title: 'Ako ste završili sa dodavanjem izolacije kliknite na dugme "Završi intervenciju"',
  list_final_middle_title: "Ukoliko želite da izolujete još neku poziciju kliknite na istu poziciju na kući.",
  list_final_title: "Završi intervenciju",
  list_position_title: "Lista pozicija",
  list_additional_title: "Ukoliko želite da izolujete još neku poziciju kliknite na istu poziciju na kući.",
  calc_final_title: "Finalni proračun",
  typ_house_tip_title: "Izaberite tip vaše kuće",
  pos_position_from_select: {
    1: "Odaberite postojeće stanje Vašeg fasadnog zida",
    5: "Odaberite postojeće stanje Vašeg ravnog krova",
    7: "Odaberite postojeće stanje Vašeg kosog krova",
    10: "Odaberite postojeće stanje Vaših prozora",
    13: "Odaberite postojeće stanje Vaših vrata",
    18: "Odaberite postojeće stanje Vašeg plafona ispod negerejanog tavana",
    19: "Odaberite postojeće stanje Vašeg poda iznad negrejanog podruma",
    20: "Odaberite postojeće stanje Vašeg zida u tlu",
    21: "Odaberite postojeće stanje Vašeg poda na tlu",
    60: "Odaberite postojeće stanje Vaših krovnih prozora",
  },
  calc_again_desktop_title: "Izračunajte ponovo",
  energy_disclaimer_title: "*Dobijeni energetski razred zavisi od tačnosti unesenih parametara",
  app_welcome_title: "Dobrodošli",
  app_politika_privatnosti_title: "http://www.kamenavuna.com/politika-privatnosti-kalkulator/",
  app_uslovi_koriscenja_title: "http://www.kamenavuna.com/uslovi-koriscenja-kalkulator/",
};
